import * as React from "react";
type Props = {
  className?: string,
};
function SvgHeart({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Heart"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 8.43372C22 13.4337 20 18.5134 12 22C5 18.5134 2 13.4337 2 8.43372C2 3.43372 8 -0.110706 12 3.43372C17.0055 -0.110706 22 3.43372 22 8.43372ZM20 8.43372C20 4.72924 16.6468 2.75233 13.3363 4.94234L13.1558 5.06594L11.861 5.98278L10.6736 4.9306C8.14898 2.69352 4 4.90919 4 8.43372C4 12.4358 6.34769 16.687 11.7877 19.6365L12.056 19.7807L12.2627 19.6845C17.9378 16.9954 19.9221 13.1014 19.9977 8.69964L20 8.43372Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgHeart;
